import { render, staticRenderFns } from "./RenderCheckLabel.vue?vue&type=template&id=e2e38e20&functional=true&"
import script from "./RenderCheckLabel.vue?vue&type=script&lang=js&"
export * from "./RenderCheckLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports